import React from "react";
import {coreUrls} from "core_src/js/core_urls_config";
import classNames from 'classnames';
import { socialConfig } from "anvil_social_src/social_config";
import { FaFacebookF } from "react-icons/fa";
import { Button, useBreakpointValue, useStyleConfig } from "@chakra-ui/react";

/**
 * Show a styled Facebook Auth button
 * @param next - URL to be redirected to after successful login
 * @param urlOverride - Navigate here instead of the normal Facebook Login path.
 * @param className - Extra class names as a string to add to the surrounding div.
 * @param aTagAttributes - Any extra parameters get added to the `a` tag as attributes.
 */
export const FacebookLoginButton = ({next, urlOverride, className, ...aTagAttributes}) => {

    const buttonSize = useBreakpointValue({ base: 'md', md: 'lg' });

    const buttonStyles = useStyleConfig("Button", {
        colorScheme: 'facebook',
    });

    // Only show Facebook login button if it is configured
    if (!socialConfig.facebook || !socialConfig.facebook.enabled) {
        return null;
    }

    const classes = classNames(className);

    let href;
    if (urlOverride) {
        href = urlOverride;
        if (next) {
            console.warn("next has no effect when urlOverride is set.")
        }
    } else {
        href = coreUrls.facebook_social_begin;
        if (next) {
            href += `?next=${encodeURIComponent(next)}`
        }
    }

    return (
        <Button as="a"
                size={buttonSize}
                isFullWidth={true}
                colorScheme="facebook"
                leftIcon={<FaFacebookF />}
                className={classes}
                href={href}
                _hover={{
                    ...buttonStyles._hover,
                    color: 'white',
                }}
                _active={{
                    ...buttonStyles._active,
                    outline: 'none',
                }}
                {...aTagAttributes}
        >
            Continue with Facebook
        </Button>
    );
}
